import module from '../../shared.module';
import moment from 'moment';
import _ from 'lodash';

module.component('suggestedList', {
  // isolated scope binding
  bindings: {
    personId: '<',
  },

  // Inline template which is bound to message variable
  // in the component controller
  templateUrl: 'app/shared/components/suggested-list/suggested-list.tpl.html',

  // The controller that handles our component logic
  controller: [
    'GiftListService',
    'FriendsService',
    '$state',
    '$rootScope',
    '$timeout',
    'CurrentUserService',
    function (GiftListService, FriendsService, $state, $rootScope, $timeout, CurrentUserService) {
      var ctrl = this;
      var personId = ctrl.personId | 0;
      var friendList;

      FriendsService.friends.then(function (data) {
        friendList = data;
      });

      ctrl.getRelativeDateTime = function (dt) {
        return moment(dt).fromNow();
      };

      ctrl.getGiftFor = function (gift) {
        var friend = _.find(friendList, { id: gift.giftFor });
        return friend ? friend.name : 'Myself';
      };

      ctrl.getDescription = function (gift) {
        var maxLength = 200;

        if (!gift.description) {
          return '';
        }

        if (gift.description.length > maxLength) {
          return `${gift.description.substring(0, maxLength)}...`;
        } else {
          return gift.description;
        }
      };

      GiftListService.suggestedBy(personId).then(function (data) {
        ctrl.list = data;
        if ($state.$current.scrollPosition) {
          $timeout(function () {}, 0, false);
        }
      });

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
        $state.$current.scrollPosition = window.scrollY;
      });
    },
  ],
});
